import { render, staticRenderFns } from "./AvailableAppointments.vue?vue&type=template&id=79e21654&scoped=true&"
import script from "./AvailableAppointments.ts?vue&type=script&lang=ts&"
export * from "./AvailableAppointments.ts?vue&type=script&lang=ts&"
import style0 from "./AvailableAppointments.scss?vue&type=style&index=0&id=79e21654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e21654",
  null
  
)

export default component.exports